// extracted by mini-css-extract-plugin
module.exports = {"SWatchlistButton":"WatchlistButton_SWatchlistButton__cY4aA","SWatchlistSvg":"WatchlistButton_SWatchlistSvg__xtb0k"};